import { Injectable, inject } from '@angular/core';
import {
  ObservatoryRepository,
  OverlayRepository,
  CrossAnalysisRepository,
  KpiRepository,
  DarkModeRepository,
  ChatRepository,
  ChatShareRepository,
  AIModelRepository,
  AIAgentRepository,
  UbigeoRepository,
  LayerRepository,
  MapRepository,
  MenuRepository,
  FocalPointRepository,
  FocalStatRepository,
  FocalLayerRepository,
  DroneTelemetryRepository,
  ArcGisQueryRepository,
  OGCRepository,
  MediationSpaceRepository,
  AgreementRepository,
  InterventionRepository,
  IndicatorRepository,
  AuthRepository,
  BasemapRepository} from '@gishub/infrastructure';
import {
  AlertRepository,
  BookmarkRepository,
  SpatialReferenceRepository,
  MonitoringRepository,
  DeforestationRepository,
  SenamhiRepository,
  OpenMeteoTemperatureRepository,
  OpenMeteoPointWeatherRepository,
} from '@gishub/infrastructure';
import { Configuration } from '../configuration/configuration';

@Injectable({ providedIn: 'root' })
export class ObservatoryRepositoryProvider {
  readonly instance = new ObservatoryRepository();
}

@Injectable({ providedIn: 'root' })
export class OverlayRepositoryProvider {
  readonly instance = new OverlayRepository();
}

@Injectable({ providedIn: 'root' })
export class CrossAnalysisRepositoryProvider {
  readonly instance = new CrossAnalysisRepository();
}

@Injectable({ providedIn: 'root' })
export class KpiRepositoryProvider {
  readonly instance = new KpiRepository();
}

@Injectable({ providedIn: 'root' })
export class DarkModeRepositoryProvider {
  readonly instance = new DarkModeRepository();
}

@Injectable({ providedIn: 'root' })
export class ChatRepositoryProvider {
  readonly instance = new ChatRepository();
}

@Injectable({ providedIn: 'root' })
export class ChatShareRepositoryProvider {
  readonly instance = new ChatShareRepository();
}

@Injectable({ providedIn: 'root' })
export class AIModelRepositoryProvider {
  readonly instance = new AIModelRepository();
}

@Injectable({ providedIn: 'root' })
export class AIAgentRepositoryProvider {
  readonly instance = new AIAgentRepository();
}

@Injectable({ providedIn: 'root' })
export class AlertRepositoryProvider {
  readonly instance = new AlertRepository();
}

@Injectable({ providedIn: 'root' })
export class UbigeoRepositoryProvider {
  readonly instance = new UbigeoRepository();
}

@Injectable({ providedIn: 'root' })
export class LayerRepositoryProvider {
  readonly instance = new LayerRepository();
}

@Injectable({ providedIn: 'root' })
export class MapRepositoryProvider {
  readonly instance = new MapRepository();
}

@Injectable({ providedIn: 'root' })
export class MenuRepositoryProvider {
  readonly instance = new MenuRepository();
}

@Injectable({ providedIn: 'root' })
export class FocalPointRepositoryProvider {
  readonly instance = new FocalPointRepository();
}

@Injectable({ providedIn: 'root' })
export class FocalStatRepositoryProvider {
  readonly instance = new FocalStatRepository();
}

@Injectable({ providedIn: 'root' })
export class FocalLayerRepositoryProvider {
  readonly instance = new FocalLayerRepository();
}

@Injectable({ providedIn: 'root' })
export class DroneTelemetryRepositoryProvider {
  readonly instance = new DroneTelemetryRepository();
}

@Injectable({ providedIn: 'root' })
export class ArcGisQueryRepositoryProvider {
  readonly instance = new ArcGisQueryRepository();
}

@Injectable({ providedIn: 'root' })
export class OGCRepositoryProvider {
  readonly instance = new OGCRepository(inject(Configuration));
}

@Injectable({ providedIn: 'root' })
export class MediationSpaceRepositoryProvider {
  readonly instance = new MediationSpaceRepository();
}

@Injectable({ providedIn: 'root' })
export class AgreementRepositoryProvider {
  readonly instance = new AgreementRepository();
}

@Injectable({ providedIn: 'root' })
export class InterventionRepositoryProvider {
  readonly instance = new InterventionRepository();
}

@Injectable({ providedIn: 'root' })
export class IndicatorRepositoryProvider {
  readonly instance = new IndicatorRepository();
}

@Injectable({ providedIn: 'root' })
export class AuthRepositoryProvider {
  readonly instance: AuthRepository;
  constructor() {
    const externalApiUrl = (window as any).__ENV?.externalApiUrl ?? 'http://localhost:8080/api/v1';
    this.instance = new AuthRepository(externalApiUrl);
  }
}

@Injectable({ providedIn: 'root' })
export class BasemapRepositoryProvider {
  readonly instance = new BasemapRepository();
}

@Injectable({ providedIn: 'root' })
export class BookmarkRepositoryProvider {
  readonly instance = new BookmarkRepository();
}

@Injectable({ providedIn: 'root' })
export class SpatialReferenceRepositoryProvider {
  readonly instance = new SpatialReferenceRepository();
}

@Injectable({ providedIn: 'root' })
export class MonitoringRepositoryProvider {
  readonly instance = new MonitoringRepository();
}

@Injectable({ providedIn: 'root' })
export class DeforestationRepositoryProvider {
  readonly instance = new DeforestationRepository();
}

@Injectable({ providedIn: 'root' })
export class SenamhiRepositoryProvider {
  readonly instance = new SenamhiRepository(inject(Configuration));
}

@Injectable({ providedIn: 'root' })
export class TemperatureRepositoryProvider {
  readonly instance = new OpenMeteoTemperatureRepository();
}

@Injectable({ providedIn: 'root' })
export class PointWeatherRepositoryProvider {
  readonly instance = new OpenMeteoPointWeatherRepository();
}

